import axios from "axios";
import Config from "src/config";

const actionEditarRespostaRapida = data => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/clientes/cliente/respostas/editar`,
        data
    });
};

export default actionEditarRespostaRapida;
